import React from 'react';
import valentineDetail from '../img/Detail/valentines-detail.jpg';
import './Detail.css';
const ValentineDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={valentineDetail} alt="Valentine's Day" />
    </div>
  );
};

export default ValentineDetail;
